export default __webpack_public_path__ + "static/media/APCOA_Parking_logo_web.3837afbf.png";